import { render } from "./manageUserToBranch.vue?vue&type=template&id=3472ea3c"
import script from "./manageUserToBranch.vue?vue&type=script&lang=js"
export * from "./manageUserToBranch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__